// extracted by mini-css-extract-plugin
export default {"container":"RenderRichText_container__av1j7"};